import React from "react";
import { Navigate } from "react-router-dom";

// Profile
import UserProfile from "../pages/Authentication/user-profile";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import ForgetPwd from "../pages/Authentication/ForgetPassword";

// Dashboard
import Dashboard from "../pages/Dashboard/index";
import Ganesh from "pages/Masters/Ganesh";
import AddEdit_UserMaster from "pages/Masters/AddEdit_UserMaster";
import PageList_UserMaster from "pages/Masters/PageList_UserMaster";
import PageList_CourseMasterH from "pages/Masters/PageList_CourseMasterH";
import AddEdit_CourseMasterH from "pages/Masters/AddEdit_CourseMasterH";
import AddEdit_CourseMasterL from "pages/Masters/AddEdit_CourseMasterL";
import PageList_CourseMasterL from "pages/Masters/PageList_CourseMasterL";
import PageList_PlanH from "pages/Masters/PageList_PlanH";
import AddEdit_PlanH from "pages/Masters/AddEdit_PlanH";
import AddEdit_PlanL from "pages/Masters/AddEdit_PlanL";
import AddEdit_MCQMasterH from "pages/Masters/AddEdit_MCQMasterH";
import PageList_MCQMasterH from "pages/Masters/PageList_MCQMasterH";
import PageList_McqMasterL from "pages/Masters/PageList_McqMasterL";
import AddEdit_McqMasterL from "pages/Masters/AddEdit_McqMasterL";
import PageList_Result from "pages/Masters/PageList_Result";
import AddEdit_CouponMaster from "pages/Masters/AddEdit_CouponMaster";
import PageList_CouponMaster from "pages/Masters/PageList_CouponMaster";
import AddEdit_QrImage from "pages/Masters/AddEdit_QrImage";
import PageList_QrImage from "pages/Masters/PageList_QrImage";
import PageList_PaymentVerify from "pages/PaymentMasters/PageList_PaymentVerify";
import AddEdit_PropertyDeal from "pages/Masters/AddEdit_PropertyDeal";
import PageList_PropertyDeal from "pages/Masters/PageList_PropertyDeal";
import AddEdit_GoldDeal from "pages/Masters/AddEdit_GoldDeal";
import PageList_GoldDeal from "pages/Masters/PageList_GoldDeal";
import AddEdit_ProductMaster from "pages/Masters/AddEdit_ProductMaster";
import PageList_ProductMaster from "pages/Masters/PageList_ProductMaster";
import PageList_CustomerReport from "pages/Masters/PageList_CustomerReport";
import PageList_CompanyMaster from "pages/Masters/PageList_CompanyMaster";
import AddEdit_CompanyMaster from "pages/Masters/AddEdit_CompanyMaster";
import AddEdit_RateTableMaster from "pages/Masters/AddEdit_RateTableMaster";
import PageList_RateTableMaster from "pages/Masters/PageList_RateTableMaster";
import AddEdit_SalesMaster from "pages/Masters/AddEdit_SalesMaster";
import PageList_SalesMaster from "pages/Masters/PageList_SalesMaster";
import AddEdit_CustomerMaster from "pages/Masters/AddEdit_CustomerMaster";
import PageList_CustomerMaster from "pages/Masters/PageList_CustomerMaster";
import AddEdit_BankMaster from "pages/Masters/AddEdit_BankMaster";
import PageList_BankMaster from "pages/Masters/PageList_BankMaster";
import PageList_RegionMaster from "pages/Masters/PageList_RegionMaster";
import AddEdit_RegionMaster from "pages/Masters/AddEdit_RegionMaster";
import AddEdit_ProductRateMaster from "pages/Masters/AddEdit_ProductRateMaster";
import PageList_ProductRateMaster from "pages/Masters/PageList_ProductRateMaster";
import SaleInvoice from "pages/Transactions.js/SaleInvoice";
import AddEdit_SalesPersonStock from "pages/Masters/AddEdit_SalesPersonStock";
import AddEdit_PlanAdd from "pages/Masters/AddEdit_PlanAdd";
import AddTransportMaster from "pages/Masters/AddTransportMaster";
import ListTransportMaster from "pages/Masters/ListTransportMaster";
import ListSaleInvoice from "pages/Transactions.js/ListSaleInvoice";
import AddEdit_ItemTypeMaster from "pages/Masters/AddEdit_ItemTypeMaster";
import PageList_ItemTypeMaster from "pages/Masters/PageList_ItemTypeMaster";
import AddEdit_WeightCategory from "pages/Masters/AddEdit_WeightCategory";
import PageList_WeightCategory from "pages/Masters/PageList_WeightCategory";
import PageList_GodownMaster from "pages/Masters/PageList_GodownMaster";
import AddEdit_GodownMaster from "pages/Masters/AddEdit_GodownMaster";
import PageList_StoreManager from "pages/Masters/PageList_StoreManager";
import AddEdit_StoreManager from "pages/Masters/AddEdit_StoreManager";
import PageList_TransporterMaster from "pages/Masters/PageList_TransporterMaster";
import AddEdit_TransporterMaster from "pages/Masters/AddEdit_TransporterMaster";
import PageList_AdminCartApprove from "pages/Masters/PageList_AdminCartApprove";
import Report_PackedStock from "pages/Reports/Report_PackedStock";
import Report_RawStock from "pages/Reports/Report_RawStock";
import Report_SalePersonStock from "pages/Reports/Report_SalePersonStock";
import Update_AmountCollection from "pages/AmountCollection/Update_AmountCollection";
import Report_AmountCollected from "pages/Reports/Report_AmountCollected";
import PageList_TransportBids from "pages/Masters/PageList_TransportBids";
import AddEdit_PumpMaster from "pages/Masters/AddEdit_PumpMaster";
import PageList_PumpMaster from "pages/Masters/PageList_PumpMaster";
import PageList_PointMaster from "pages/Masters/PageList_PointMaster";
import AddEdit_PointsMaster from "pages/Masters/AddEdit_PointsMaster";
import AddEdit_WorkerMaster from "pages/Masters/AddEdit_WorkerMaster";
import PageList_WorkerMaster from "pages/Masters/PageList_WorkerMaster";
import AddRate from "pages/Masters/AddRate";
import PageList_Rate from "pages/Masters/PageList_Rate";
import PageList_PointsEntry from "pages/Masters/PageList_PointsEntry";
import Report_DetailedWorker from "pages/Reports/Report_DetailedWorker";
import PrivacyPolicy from "pages/PrivacyPolicy/PrivacyPolicy";

const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  // //profile
  { path: "/profile", component: <UserProfile /> },
  
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
   ,

{ path: "/RateMaster", component: <PageList_Rate/> },
{ path: "/AddRate", component: <AddRate/> },

{ path: "/WorkerMaster", component: <PageList_WorkerMaster/> },
{ path: "/AddWorker", component: <AddEdit_WorkerMaster/> },

{ path: "/PumpMaster", component: <PageList_PumpMaster/> },
{ path: "/AddPump", component: <AddEdit_PumpMaster/> },

{ path: "/pointmaster", component: <PageList_PointMaster/> },
{ path: "/AddPoint", component: <AddEdit_PointsMaster/> },

{ path: "/PointsEntry", component: <PageList_PointsEntry/> },
{ path: "/DetailedReport", component: <Report_DetailedWorker/> },



// -------------------------------------------------------------------------------
  //Report
  { path: "/PackedStockReport", component: <Report_PackedStock/> },
  { path: "/RawStockReport", component: <Report_RawStock/> },
  { path: "/SalesStockReport", component: <Report_SalePersonStock/> },
  { path: "/AmountCollected", component: <Report_AmountCollected/> },
  { path: "/AmountCollection", component: <Update_AmountCollection/> },

  { path: "/CustomerReport", component: <PageList_CustomerReport/> },
  { path: "/AdminCartApprove", component: <PageList_AdminCartApprove/> },

  { path: "/SaleInvoice", component: <SaleInvoice/> },
  { path: "/ListSaleInvoice", component: <ListSaleInvoice/> },

  { path: "/PlanAdd", component: <AddEdit_PlanAdd/> },
  
  
  { path: "/GodownMaster", component: <PageList_GodownMaster/> },
  { path: "/AddGodown", component: <AddEdit_GodownMaster/> },

  { path: "/TransporterMaster", component: <PageList_TransporterMaster/> },
  { path: "/AddTransporter", component: <AddEdit_TransporterMaster/> },

  { path: "/StoreManager", component: <PageList_StoreManager/> },
  { path: "/AddStoreManager", component: <AddEdit_StoreManager/> },

  { path: "/ItemTypeMaster", component: <PageList_ItemTypeMaster/> },
  { path: "/addItemType", component: <AddEdit_ItemTypeMaster/> },

  { path: "/WeightCategory", component: <PageList_WeightCategory/> },
  { path: "/AddWeight", component: <AddEdit_WeightCategory/> },

  { path: "/AddRate", component: <AddEdit_RateTableMaster/> },
  { path: "/AddTransportMaster", component: <AddTransportMaster/> },
  { path: "/TransportBid", component: <PageList_TransportBids/> },
  { path: "/ListTransportMaster", component: <ListTransportMaster/> },
  { path: "/RateMaster", component: <PageList_RateTableMaster/> },
  
  { path: "/AddProductRate", component: <AddEdit_ProductRateMaster/> },
  { path: "/EditProductRate", component: <AddEdit_ProductRateMaster/> },
  { path: "/ProductRateMaster", component: <PageList_ProductRateMaster/> },

  { path: "/AddProduct", component: <AddEdit_ProductMaster/> },
  { path: "/EditProduct", component: <AddEdit_ProductMaster/> },
  { path: "/ProductMaster", component: <PageList_ProductMaster/> },

  { path: "/AddCompany", component: <AddEdit_CompanyMaster/> },
  { path: "/EditCompany", component: <AddEdit_CompanyMaster/> },
  { path: "/CompanyMaster", component: <PageList_CompanyMaster/> },
  
  { path: "/AddRegion", component: <AddEdit_RegionMaster/> },
  { path: "/EditRegion", component: <AddEdit_RegionMaster/> },
  { path: "/RegionMaster", component: <PageList_RegionMaster/> },
  
  { path: "/AddBank", component: <AddEdit_BankMaster/> },
  { path: "/EditBank", component: <AddEdit_BankMaster/> },
  { path: "/BankMaster", component: <PageList_BankMaster/> },

  { path: "/AddSales", component: <AddEdit_SalesMaster/> },
  { path: "/EditSales", component: <AddEdit_SalesMaster/> },
  { path: "/SalesMaster", component: <PageList_SalesMaster/> },

  { path: "/SalesPersonStock", component: <AddEdit_SalesPersonStock/> },



  { path: "/AddCustomer", component: <AddEdit_CustomerMaster/> },
  { path: "/EditCustomer", component: <AddEdit_CustomerMaster/> },
  { path: "/CustomerMaster", component: <PageList_CustomerMaster/> },

  { path: "/AddUser", component: <AddEdit_UserMaster/> },
  { path: "/EditUser", component: <AddEdit_UserMaster/> },
  { path: "/UserMaster", component: <PageList_UserMaster/> },
// ------------------------------------------------------------------------------------------------------
  { path: "/Ganesh", component: <Ganesh /> },


  { path: "/AddCourseH", component: <AddEdit_CourseMasterH/> },
  { path: "/EditCourseH", component: <AddEdit_CourseMasterH/> },
  { path: "/CourseMasterH", component: <PageList_CourseMasterH/> },

  { path: "/AddCourseL", component: <AddEdit_CourseMasterL/> },
  { path: "/EditCourseL", component: <AddEdit_CourseMasterL/> },
  { path: "/CourseMasterL", component: <PageList_CourseMasterL/> },

  { path: "/AddPlanH", component: <AddEdit_PlanH/> },
  { path: "/EditPlanH", component: <AddEdit_PlanH/> },
  { path: "/PlanMasterH", component: <PageList_PlanH/> },
  { path: "/PlanMasterL", component: <AddEdit_PlanL/> },

  { path: "/AddMCQH", component: <AddEdit_MCQMasterH/> },
  { path: "/EditMCQH", component: <AddEdit_MCQMasterH/> },
  { path: "/MCQMasterH", component: <PageList_MCQMasterH/> },

  { path: "/AddMcqL", component: <AddEdit_McqMasterL/> },
  { path: "/EditMcqL", component: <AddEdit_McqMasterL/> },
  { path: "/MCQMasterL", component: <PageList_McqMasterL/> },

  { path: "/AddCoupon", component: <AddEdit_CouponMaster/> },
  { path: "/EditCoupon", component: <AddEdit_CouponMaster/> },
  { path: "/CouponMaster", component: <PageList_CouponMaster/> },

  { path: "/AddQrImage", component: <AddEdit_QrImage/> },
  { path: "/EditQrImage", component: <AddEdit_QrImage/> },
  { path: "/QrImage", component: <PageList_QrImage/> },

  { path: "/Result", component: <PageList_Result/> },
  { path: "/PaymentVerify", component: <PageList_PaymentVerify/> },
  //KreditBeast
  { path: "/AddPropertyDeal", component: <AddEdit_PropertyDeal/> },
  { path: "/EditPropertyDeal", component: <AddEdit_PropertyDeal/> },
  { path: "/propertyDeal", component: <PageList_PropertyDeal/> },

  { path: "/AddGoldDeal", component: <AddEdit_GoldDeal/> },
  { path: "/EditGoldDeal", component: <AddEdit_GoldDeal/> },
  { path: "/GoldDeal", component: <PageList_GoldDeal/> },
];

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/PrivacyPolicy", component: <PrivacyPolicy /> },
];

export { authProtectedRoutes, publicRoutes };
